import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_IMMUNIZATION_REQUEST: '',
  GET_IMMUNIZATION_SUCCESS: '',
  GET_IMMUNIZATION_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityImmunization');

export default types;
